import producerCompliancePolicyAttachmentsReducer from 'Agent/AgentDocumentation/ducks/producerCompliancePolicyAttachments';

export default {
  producerCompliancePolicyAttachments: producerCompliancePolicyAttachmentsReducer,
};
